module.exports = __webpack_public_path__ + "img/home-slogan-parallax.2626b3bb.jpg";